import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_74b8fwfz3v: FaireBrandEntity = {
  token: "b_74b8fwfz3v",
  type: "brand",
  name: "Rocket Bug",
  avatarUrl:
    "https://cdn.faire.com/fastly/e64c99d08064e204b413333c76eaae99dc14f17bf2bead6f1c39f10c8970312a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/feda6f32f16d55b8fe5167e897f37dd66e933836f1118684655af1c516ef2e75.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e64c99d08064e204b413333c76eaae99dc14f17bf2bead6f1c39f10c8970312a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/feda6f32f16d55b8fe5167e897f37dd66e933836f1118684655af1c516ef2e75.jpeg",
  location: "Hillsborough, NC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Rocket Bug, in operation since 2006, is a women-owned, two person team. Our focus is creating modern takes on classic staples that are comfortable and high quality. We have worked with our manufacturing partner for thirteen years to create a line of super soft rompers and gowns in must have colors. In addition to our flagship line, we have grown to include knits, sweatshirts, dresses, and more. Rocket Bug regularly adds to our portfolio by monitoring trends and developing products that are sellable and unique.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:44.361Z",
    importedBy: "entity-db-cli",
  },
};
